<div class="modern-card" [ngClass]="cardBackgroundClass" (click)="onCardClick(card)">
  @if (card.srv_background_image) {
    <div class="image-overlay" [ngStyle]="getImageOverlayStyles()"></div>
  }

  <!-- Card Header -->
  <div class="card-header">
    @if (card.srv_show_icon && card.srv_icon) {
      <div class="card-icon">
        <icon [ngClass]="card.srv_icon"></icon>
      </div>
    }
    @if (card.srv_show_cmp_logo && card.company?.cmp_logo_b64) {
      <div class="card-logo">
        <img [src]="'data:image/png;base64,' + $safeNavigationMigration(card.company?.cmp_logo_b64)" style="height: 100%; border-radius: 8px" />
      </div>
    }
    @if (card.srv_show_badge) {
      <div class="card-badge">
        {{ card.srv_badge }}
      </div>
    }
    <!-- Pulsante salva in dashboard -->
    @if (card.srv_show_save_to_dashboard) {
      <button
        pButton iconOnly
        type="button"
       
        class="p-button-rounded p-button-text save-dashboard-btn"
        pTooltip="Aggiungi alla Dashboard"
        tooltipPosition="top"
        (click)="saveToDashboard($event)"><i class="p-button-icon pi pi-th-large"></i></button>
    }
  </div>

  <!-- Card Content -->
  <div class="card-content">
    @if (card.srv_show_company_name && card.company?.name) {
      <h3 class="company-name">
        {{ card.company?.name }}
      </h3>
    }
    @if (card.srv_show_service_name && card.srv_name_view) {
      @if (!(card.srv_show_company_name && card.company?.name)) {
        <h3 class="service-name service-name-hero">
          {{ card.srv_name_view }}
        </h3>
      } @else {
        <p class="service-name">{{ card.srv_name_view }}</p>
      }
    }
    @if (card.srv_description) {
      <p class="description">
        {{ card.srv_description }}
      </p>
    }
  </div>
</div>
